// Calendar.js

import React, { useState , useRef, useEffect, useMemo, memo} from 'react';
import styles from './calendar.module.css';
import Grid from '@mui/material/Unstable_Grid2';
import Avatar from '@mui/material/Avatar';

import FriendsList from '../../miscellaneous/FriendsList/FriendsList.jsx';
import { Link } from "react-router-dom";

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import Paper from '@mui/material/Paper';
import { Category, Height } from '@mui/icons-material';

import { CgCheck } from "react-icons/cg";    // Check mark overlaying the profile pic. 
// import { IoIosCheckmark } from "react-icons/io";
// import { BsCheck } from "react-icons/bs";

import { IoMdClose } from "react-icons/io";

import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import DiscussAndLearnArea from '../DiscussAndLearnArea/DiscussAndLearnArea.jsx';
import { gridClasses } from '@mui/material';
import { flushSync } from 'react-dom';

import { use } from 'react';
import NeedleOverlayBox from './NeedleOverlayBox/NeedleOverlayBox.jsx';

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
//---------------------------------------------------------------------------------


const Calendar = memo (function (props) {
  const {isMobile, datesWithDayMonthYear, setDatesWithDayMonthYear, calendarMonthAndYear, setCalendarMonthAndYear, smallCalendarSelectedDate ,showFriendsList, setShowFriendsList, subject, category, heightOfCalendarGrid, setHeightOfCalendarGrid, clickedGridTimeInDayHourMinute, setClickedGridTimeInDayHourMinute} = useGlobalState();

  const [calendarRenderSessionArray, setCalendarRenderSessionArray]=useState([]);
  const [mySessionsCalendarRenderSessionArray, setMySessionsCalendarRenderSessionArray] = useState([]);

  //const [datesWithDayMonthYear, setDatesWithDayMonthYear] = useState([{'dayNumber':'','month':'','year':''}]);

  const [pastOrPresentOrFuture, setPastOrPresentOrFuture] = useState('present');   //future or past.

  const [singleDayDateForMobile, setSingleDayDateForMobile] = useState(dayjs());   //For mobile view.

  const today = dayjs();

  console.log("---$$$$$$$$$$$$$$$$$$$$$$$---");




  //---------------- Creating the calendar left and right arrow click functionality. ---------------------
  const [numberOfTimesCalendarArrowClicked, setNumberOfTimesCalendarArrowClicked] = useState(0);   //calendar left and right arrow.   //What should happen when it is in mobile view?
  function calendarArrowClicked(arrow){
    if(arrow === 'left'){
      setNumberOfTimesCalendarArrowClicked((prev)=>prev-1);
    }else if (arrow === 'right'){
      setNumberOfTimesCalendarArrowClicked((prev)=>prev+1);
    }
  }
  //----------------------------------------------------------------------------------------------------





  //The below datesWithDayMonthYear does not update when the day switches over. Need to add a useEffect to update it when the day switches over.
  //---------------- Setting the dates for the week in datesWithDayMonthYearArray state for calendar head row. ---------------------
  useEffect(()=>{

    if (isMobile === false){
      //----For laptop----
      //const today = dayjs();                    //Should it also be here?
      const selectedDay = dayjs(smallCalendarSelectedDate);     //Converts smallCalendarSelectedDate into dayjs format.
      /*
      console.log("tttttttttttoday : "+today);
      console.log("tttttttttttoday smallCalendarSelectedDate : "+smallCalendarSelectedDate);
      */

      let indexOfWeekday = selectedDay.day();          // 0 for Sunday, 1 for Monday, ..., 6 for Saturday.
      
      indexOfWeekday = (indexOfWeekday + 6) % 7;      // To make it like - 0 for Monday, 1 for tuesday, 2 for wednesday, 3 for thursday, 4 for friday, 5 for saturday and 6 for sunday.    
      let datesWithDayMonthYearArray = [];


      for (let i = 0; i < 7; i++) {
        //For time needle overly box.
        let calculatedDate = selectedDay.subtract(indexOfWeekday - i - 7*numberOfTimesCalendarArrowClicked, 'day');
        //let calculatedDate = smallCalendarSelectedDate.subtract(indexOfWeekday - i - 7*numberOfTimesCalendarArrowClicked, 'day');
        

        datesWithDayMonthYearArray.push({
          'dayNumber': calculatedDate.format('D'), //The output is a string.
          'month': calculatedDate.format('M'), 
          'year': calculatedDate.format('YYYY')
        });

        if (i===0){   // Checking for i===0 because we are checking for the first day of the week. If the first day is in the past or future or present, then the whole week is in the past or future or present. 
          if (calculatedDate.isBefore(today, 'day')){
            setPastOrPresentOrFuture('past');
          }else if (calculatedDate.isAfter(today, 'day')){
            setPastOrPresentOrFuture('future');
          }else if (calculatedDate.isSame(today, 'day')){  //Actually, if the week is the present week it should set as present. But it doesn't matter as we are not using the state for the present week.
            setPastOrPresentOrFuture('present');
          }
        }
        
        /*
        datesWithDayMonthYearArray.push({
          dayNumber: calculatedDate.format('D'),   //The key is not a string here.
          month: calculatedDate.format('M'), 
          year: calculatedDate.format('YYYY')
        });
        */
      }

      //console.log("datesWithDayMonthYearArray : "+JSON.stringify(datesWithDayMonthYearArray));   
      setDatesWithDayMonthYear(datesWithDayMonthYearArray);     // [{dayNumber:'14',month:'10',year:'2024'}, {dayNumber:'15',month:'10',year:'2024'}, {dayNumber:'16',month:'10',year:'2024'}, {dayNumber:'17',month:'10',year:'2024'}, {dayNumber:'18',month:'10',year:'2024'}, {dayNumber:'19',month:'10',year:'2024'}, {dayNumber:'20',month:'10',year:'2024'}]
    
    }else if (isMobile === true){
      //----For mobile----
      // Similarly, comopute DatesWithDayMonthYear for mobile view wherein only one day is displayed instead of 7 days.
      //const today = dayjs();                    //Should it be here?
      const selectedDay = dayjs(smallCalendarSelectedDate);     //Converts smallCalendarSelectedDate into dayjs format.
      /*
      console.log("tttttttttttoday : "+today);
      console.log("tttttttttttoday smallCalendarSelectedDate : "+smallCalendarSelectedDate);
      */
      let datesWithDayMonthYearArray = [];

      let calculatedDate = selectedDay.subtract(-numberOfTimesCalendarArrowClicked, 'day');  //I guess it should be -numberOfTimesCalendarArrowClicked.

      setSingleDayDateForMobile(calculatedDate);   //For mobile view.

      datesWithDayMonthYearArray.push({
        'dayNumber': calculatedDate.format('D'), //The output is a string.
        'month': calculatedDate.format('M'), 
        'year': calculatedDate.format('YYYY')
      });

      if (calculatedDate.isBefore(today, 'day')){
        setPastOrPresentOrFuture('past');
      }else if (calculatedDate.isAfter(today, 'day')){
        setPastOrPresentOrFuture('future');
      }else if (calculatedDate.isSame(today, 'day')){  //Actually, if the week is the present week it should set as present. But it doesn't matter as we are not using the state for the present week.
        setPastOrPresentOrFuture('present');
      }

      setDatesWithDayMonthYear(datesWithDayMonthYearArray);    
      
    }

  },[numberOfTimesCalendarArrowClicked, smallCalendarSelectedDate, isMobile]);      // Only re-run the effect if this second parameter changes. Here we have to give a state if we are to give something. If nothing given (as in if it is left blank), it will re-run the effect everytime there is some change (any change).
  //------------------------------------------------------------------------------------------------------------------






  //---------------Setting the weekday names and dates.----------------------

  /*
  const weekdayNamesAndDates = datesWithDayMonthYear.length === 7 ? [
      ['Monday', datesWithDayMonthYear[0]['dayNumber']],
      ['Tuesday', datesWithDayMonthYear[1]['dayNumber']],
      ['Wednesday', datesWithDayMonthYear[2]['dayNumber']],
      ['Thursday', datesWithDayMonthYear[3]['dayNumber']],
      ['Friday', datesWithDayMonthYear[4]['dayNumber']],
      ['Saturday', datesWithDayMonthYear[5]['dayNumber']],
      ['Sunday', datesWithDayMonthYear[6]['dayNumber']]
    ]
  : []; // Empty array if datesWithDayMonthYear is not yet populated
  */
  

  // If not given like this without memo, numbers get inverted when changing year by pressing left and right arrow.  
  // In React, every time a component re-renders (due to state or prop changes), all the variables and functions inside it are re-created. With useMemo, React memoizes (caches) the value of weekdayNamesAndDates and only recalculates it when datesWithDayMonthYear changes. But does it change when datesWithDayMonthYear changes the order of the dates? I think it does.
  // Memoizing weekday names and dates.
  
  //Here useMemo is used because we don't want it to calculate every time a state changes and re-renders the whole component. We want it to calculate only when the datesWithDayMonthYear changes.
  const weekdayNamesAndDates = useMemo(
    () => datesWithDayMonthYear.length === 7 ? [
        ['Monday', datesWithDayMonthYear[0].dayNumber],
        ['Tuesday', datesWithDayMonthYear[1].dayNumber],
        ['Wednesday', datesWithDayMonthYear[2].dayNumber],
        ['Thursday', datesWithDayMonthYear[3].dayNumber],
        ['Friday', datesWithDayMonthYear[4].dayNumber],
        ['Saturday', datesWithDayMonthYear[5].dayNumber],
        ['Sunday', datesWithDayMonthYear[6].dayNumber]
      ] : [],
    [datesWithDayMonthYear] // Recalculate when datesWithDayMonthYear changes.
  );
  
  //----------------------------------------------------






  //------------Setting the numberOfTimesCalendarArrowClicked value to 0 when a date is selected from the small calendar-------------
  useEffect(()=>{
    setNumberOfTimesCalendarArrowClicked(0);
  },[smallCalendarSelectedDate])
  //---------------------------------------------------------------------------------------------------------------------------------






  //---------------------Setting the calendarMonthAndYear------------------------------------

  useEffect(() => {
    const uniqueMonths = new Set(datesWithDayMonthYear.map(date => date.month));
    const uniqueYears = new Set(datesWithDayMonthYear.map(date => date.year));

    const monthNames = {
      '01': 'January', '02': 'February', '03': 'March', '04': 'April',
      '05': 'May', '06': 'June', '07': 'July', '08': 'August',
      '09': 'September', '10': 'October', '11': 'November', '12': 'December'
    };

    if (uniqueMonths.size === 1 && uniqueYears.size === 1) {
      // All dates are in the same month and year
      const month = monthNames[[...uniqueMonths][0].padStart(2, '0')];
      const year = [...uniqueYears][0];
      setCalendarMonthAndYear(`${month} ${year}`);
    } else if (uniqueYears.size === 2){
      // Dates span across two months
      //console.log("mmmmmmndex datesWithDayMOnthYear :"+JSON.stringify(datesWithDayMonthYear));


      const sortedDates = [...datesWithDayMonthYear].sort((a, b) => a.month - b.month || a.dayNumber - b.dayNumber);    //[...datesWithDayMonthYear] to avoid mutating the original array.
      //console.log("sortedDates : "+JSON.stringify(sortedDates));
      const firstDate = sortedDates[0];
      const lastDate = sortedDates[sortedDates.length - 1];
      
      const startMonth = monthNames[lastDate.month.padStart(2, '0')].slice(0, 3);
      const startYear = lastDate.year;
      const endMonth = monthNames[firstDate.month.padStart(2, '0')].slice(0, 3);
      const endYear = firstDate.year;

      //console.log("nnnnnndex datesWithDayMOnthYear :"+JSON.stringify(datesWithDayMonthYear));

      setCalendarMonthAndYear(`${startMonth}' ${startYear} - ${endMonth}' ${endYear}`);
    }  else {
      // Dates span across two months
      //console.log("mmmmmmndex datesWithDayMOnthYear :"+JSON.stringify(datesWithDayMonthYear));


      const sortedDates = [...datesWithDayMonthYear].sort((a, b) => a.month - b.month || a.dayNumber - b.dayNumber);     //[...datesWithDayMonthYear] to avoid mutating the original array.
      //console.log("sortedDates : "+JSON.stringify(sortedDates));
      const firstDate = sortedDates[0];
      const lastDate = sortedDates[sortedDates.length - 1];
      
      const startMonth = monthNames[firstDate.month.padStart(2, '0')].slice(0, 3);
      const startYear = firstDate.year;
      const endMonth = monthNames[lastDate.month.padStart(2, '0')].slice(0, 3);
      const endYear = lastDate.year;

      //console.log("nnnnnndex datesWithDayMOnthYear :"+JSON.stringify(datesWithDayMonthYear));

      setCalendarMonthAndYear(`${startMonth}' ${startYear} - ${endMonth}' ${endYear}`);
    }
  }, [datesWithDayMonthYear, numberOfTimesCalendarArrowClicked]);
  //-------------------------------------------------------------------------------------------






  //----------------Setting todaysColumnNumber const for the time needle.---------------------
  //Here useMemo is used because we don't want it to calculate every time a state changes and re-renders the whole component. We want it to calculate only when the datesWithDayMonthYear changes.
  const todaysColumnNumber = useMemo(() => {
    const now = new Date();
    //console.log("getDaycolumnNumberOfToday:", now.getDate());
    //console.log("getHourcolumnNumberOfToday:", now.getHours());
    //console.log("getMinutescolumnNumberOfToday:", now.getMinutes());

    //console.log("datesWithDayMonthYear:", JSON.stringify(datesWithDayMonthYear));
    const columnNumberOfTodayFor909And303Grids = 2 + datesWithDayMonthYear.findIndex(item =>   //Plus 2 because of the timeslot column, and because the datesWithDayMonthYear array starts with 0.
      Number(item.dayNumber) === now.getDate() &&
      Number(item.month) === (now.getMonth() + 1) &&
      Number(item.year) === now.getFullYear()
    );

    //console.log("columnNumberOfToday:", columnNumberOfTodayFor909And303Grids);
    return columnNumberOfTodayFor909And303Grids;
  }, [datesWithDayMonthYear]);
  //-------------------------------------------------------------------------------------------











  //---------------Setting the needleOverlayBoxGridIndex state for the time needle overlay box.---------------------
  //!!!!!!!!!!!!!!!!!!!!! Is this needed? Actually the one line below this is enough but you have to do some more things like check for if datesWithDayMonthYear is defined yet or not before computing todaysColumnNumber.
  
  const [needleOverlayBoxGridIndex, setNeedleOverlayBoxGridIndex] = useState([0]);    //Think about this...  It was 3. So it used to switch from 3 to whatever is today's column.
  
  useEffect(()=>{
    setNeedleOverlayBoxGridIndex([todaysColumnNumber-1]);     //0 if the today's date is not in the datesWithDayMonthYear array.
    //console.log("1needleOverlayBoxGridIndex : "+needleOverlayBoxGridIndex);
  }, [todaysColumnNumber]);    
  
  //!!!!!!
  //const needleOverlayBoxGridIndex = [todaysColumnNumber-1];      //If todays date is not in the datesWithDayMonthYear array, then todaysColumnNumber will be 1 and so needleOverlayBoxGridIndex will be 0.
  //-------------------------------------------------------------------------------------------










  //----------convertGridIndexToTimeInDayHourMinute  [Used when a session is being booked, to convert grid index to time. To be send to backend]----------

  function convert909GridIndexToTimeInDayHourMinute(gridIndexFor909Grids){
    //console.log("p : "+gridIndexFor909Grids); //12

    //get minute
    const gridNumberFor909Grids = gridIndexFor909Grids+1;   //13
    //console.log("po : "+gridNumberFor909Grids);

    const rowNumberFor909Grids = Math.floor(gridNumberFor909Grids/9)+1;  
    //console.log("o : "+rowNumberFor909Grids);

    //get hour
    //const hour = Math.floor(rowNumberFor909Grids/4);  
    const hour = Math.floor((rowNumberFor909Grids-1)/4);  
    
    //const minute = 15*((rowNumberFor909Grids%4)-1);  
    const minute = 15*((rowNumberFor909Grids-1)%4);

    //get day.
    const columnNumberFor909Grids = gridNumberFor909Grids - 9*(rowNumberFor909Grids-1);
    //console.log("i : "+columnNumberFor909Grids);

    //Below Number given to convert to number from string.
    const day = Number(datesWithDayMonthYear[columnNumberFor909Grids-2]['dayNumber']);    //Minus 2 because of the timeslot column, and because the dates array starts with 0.
    //console.log("u : "+day);

    const month = Number(datesWithDayMonthYear[columnNumberFor909Grids-2]['month']);    //Minus 2 because of the timeslot column, and because the dates array starts with 0.
    //console.log("e : "+day);

    const year = Number(datesWithDayMonthYear[columnNumberFor909Grids-2]['year']);    //Minus 2 because of the timeslot column, and because the dates array starts with 0.
    //console.log("w : "+day);

    //return [day, hour, minute];
    return {"year" : year , "month" : month , "dayNumber" : day, "hour" : hour, "minute" : minute};
  }



  function convert303GridIndexToTimeInDayHourMinute(gridIndexFor303Grids){  
    //get minute
    const gridNumberFor303Grids = gridIndexFor303Grids+1;   //13

    const rowNumberFor303Grids = Math.floor(gridNumberFor303Grids/3)+1;  

    //get hour
    //const hour = Math.floor(rowNumberFor303Grids/4);  
    const hour = Math.floor((rowNumberFor303Grids-1)/4);  
    
    //const minute = 15*((rowNumberFor303Grids%4)-1);  
    const minute = 15*((rowNumberFor303Grids-1)%4);

    //get day.
    //Actually for 303 grids you need not do this below thing instead you can give datesWithDayMonthYear[0] I guess as there is only one day in the array.
    //const columnNumberFor303Grids = gridNumberFor303Grids - 3*(rowNumberFor303Grids-1);

    //Actually for 303 grids you need not do this below thing instead you can give datesWithDayMonthYear[0] I guess as there is only one day in the array.
    //Below Number given to convert to number from string.
    //const day = Number(datesWithDayMonthYear[columnNumberFor303Grids-2]['dayNumber']);    //Minus 2 because of the timeslot column, and because the dates array starts with 0.
    const day = Number(datesWithDayMonthYear[0]['dayNumber']);

    //const month = Number(datesWithDayMonthYear[columnNumberFor303Grids-2]['month']);    //Minus 2 because of the timeslot column, and because the dates array starts with 0.
    const month = Number(datesWithDayMonthYear[0]['month']);
    
    //const year = Number(datesWithDayMonthYear[columnNumberFor303Grids-2]['year']);    //Minus 2 because of the timeslot column, and because the dates array starts with 0.
    const year = Number(datesWithDayMonthYear[0]['year']);

    //return [day, hour, minute];
    return {"year" : year , "month" : month , "dayNumber" : day, "hour" : hour, "minute" : minute};
  }
  
  //-----------------------------------------------------------------------------------------------











  // -----------convert Time To Calendar Grid Number [Used when - Given session from the backend (which has only time) to plot in the calendar]-------------

  function convertTimeToCalendar909GridNumber(backendGivenYear, backendGivenMonth, backendGivenDay, backendGivenHour, backendGivenMinute){
    //-----Getting columnNumberFor909Grids based on date for displaying info on each calendar grid.--------------
    //const backendGivenDay = 18;   // 1 to 31.

    const columnNumberFor909Grids = 2+datesWithDayMonthYear.findIndex(date => (date.year === backendGivenYear.toString() && date.month === backendGivenMonth.toString() && date.dayNumber === backendGivenDay.toString()));    //Plus 2 because of the timeslot column, and because the dates array starts with 0.
    //console.log("datesWithDayMonthYear ---------> : "+datesWithDayMonthYear);    
    //console.log("columnNumberFor909Grids : "+columnNumberFor909Grids);    


    //------Getting row number for 909 grids based on date for displaying info on each calendar grid.------------
    //const backendGivenHour = 17;
    //const backendGivenMinute = 30;   //So in each day there are in total (4 x 24 = 96 rows)+(4 x 1 = 4 last rows) = 100 rows.

    const rowNumberFor909Grids = 4*backendGivenHour+Math.floor(backendGivenMinute/15);
    //console.log("rowNumberFor909Grids : "+rowNumberFor909Grids);


    //------Getting grid number for 909 grids for displaying info on each calendar grid.------------
    const gridNumberFor909Grids = (rowNumberFor909Grids)*9+columnNumberFor909Grids;
    const gridNumberFor909GridsMinus1 = gridNumberFor909Grids-1;
    //console.log("gridNumberFor909Grids : "+gridNumberFor909Grids);
    return [gridNumberFor909GridsMinus1, gridNumberFor909Grids, columnNumberFor909Grids, rowNumberFor909Grids ];
  }

  

  function convertTimeToCalendar303GridNumber(backendGivenYear, backendGivenMonth, backendGivenDay, backendGivenHour, backendGivenMinute){
    //-----Getting columnNumberFor909Grids based on date for displaying info on each calendar grid.--------------
    //const backendGivenDay = 18;   // 1 to 31.

    //const columnNumberFor303Grids = 2;   //This is wrong... //For 303 grids, there is only one day in the array. So it is always 2.
    const columnNumberFor303Grids = 2+datesWithDayMonthYear.findIndex(date => (date.year === backendGivenYear.toString() && date.month === backendGivenMonth.toString() && date.dayNumber === backendGivenDay.toString()));    //Plus 2 because of the timeslot column, and because the dates array starts with 0.
    //console.log("datesWithDayMonthYear ---------> : "+datesWithDayMonthYear);    
    //console.log("columnNumberFor909Grids : "+columnNumberFor909Grids);    


    //------Getting row number for 909 grids based on date for displaying info on each calendar grid.------------
    //const backendGivenHour = 17;
    //const backendGivenMinute = 30;   //So in each day there are in total (4 x 24 = 96 rows)+(4 x 1 = 4 last rows) = 100 rows.

    const rowNumberFor303Grids = 4*backendGivenHour+Math.floor(backendGivenMinute/15);


    //------Getting grid number for 303 grids for displaying info on each calendar grid.------------
    const gridNumberFor303Grids = (rowNumberFor303Grids)*3+columnNumberFor303Grids;
    const gridNumberFor303GridsMinus1 = gridNumberFor303Grids-1;
    //console.log("gridNumberFor909Grids : "+gridNumberFor909Grids);
    return [gridNumberFor303GridsMinus1, gridNumberFor303Grids, columnNumberFor303Grids, rowNumberFor303Grids ];
  }
  //------------------------------------------------------------------------------------------------------------------------





  //-----convertTimeSessionArrayTo909GridNumberSessionArray [Used when - Given session from the backend (which has only time) to plot in the calendar]--------
  function convertTimeSessionArrayTo909GridNumberSessionArray(array) {
    // Ensure that 'array' is defined and is an array before calling map
    if (!Array.isArray(array)) {
      console.error("convertTimeSessionArrayTo909GridNumberSessionArray: Provided data is not an array:", array);
      return [];  // Return an empty array if the input is not valid
    }

    return array.map(item => {
      const [gNumberMinus1, gNumber, cNumber, rNumber] = convertTimeToCalendar909GridNumber(item.year, item.month, item.day, item.hour, item.minutes);
      return {
        gridNumberMinus1: gNumberMinus1,
        gridNumber: gNumber,
        columnNumber: cNumber,
        rowNumber: rNumber,
        ...item // Spread the original object properties
      };
    });
  }


  function convertTimeSessionArrayTo303GridNumberSessionArray(array) {
    // Ensure that 'array' is defined and is an array before calling map
    if (!Array.isArray(array)) {
      console.error("convertTimeSessionArrayTo303GridNumberSessionArray: Provided data is not an array:", array);
      return [];  // Return an empty array if the input is not valid
    }

    return array.map(item => {
      const [gNumberMinus1, gNumber, cNumber, rNumber] = convertTimeToCalendar303GridNumber(item.year, item.month, item.day, item.hour, item.minutes);
      return {
        gridNumberMinus1: gNumberMinus1,
        gridNumber: gNumber,
        columnNumber: cNumber,
        rowNumber: rNumber,
        ...item // Spread the original object properties
      };
    });
  }
  //-----------------------------------------------------------------------------------------------






  //-------------------calendarRenderSessionArray (all sessions basically)---------------------
  useEffect(()=>{
    if (isMobile === false){
      setCalendarRenderSessionArray(convertTimeSessionArrayTo909GridNumberSessionArray(props.calendarSessionArrayProp));   //change.
      //console.log("1calendarRenderSessionArray : "+JSON.stringify(calendarRenderSessionArray, null, 2));
      //console.log("yooooooooooooooooooooooooooooooooooooo : "+datesWithDayMonthYear);
    }else if (isMobile === true){
      setCalendarRenderSessionArray(convertTimeSessionArrayTo303GridNumberSessionArray(props.calendarSessionArrayProp));   //Change 303 for calendarRenderSessionArray
      //console.log("1calendarRenderSessionArray : "+JSON.stringify(calendarRenderSessionArray, null, 2));
      //console.log("yooooooooooooooooooooooooooooooooooooo : "+datesWithDayMonthYear);
    }
  },[datesWithDayMonthYear, props.calendarSessionArrayProp, subject, category, isMobile])   //mySessionsCalendarRenderSessionArray
  //---------------------------------------------------------------------------------

  //Enabled for correcting mobile sessions rendering issue.
  useEffect(()=>{
    console.log("output props.calendarSessionArrayProp : "+JSON.stringify(props.calendarSessionArrayProp, null, 2));
    console.log("output calendarRenderSessionArray : "+JSON.stringify(calendarRenderSessionArray, null, 2));
  },[calendarRenderSessionArray])


  //---------------------------- mySessions-----------------------------------------
  useEffect(()=>{
    if (isMobile === false){
      setMySessionsCalendarRenderSessionArray(convertTimeSessionArrayTo909GridNumberSessionArray(props.mySessions));    //change.
      //console.log("1mySessionsCalendarRenderSessionArray : "+JSON.stringify(mySessionsCalendarRenderSessionArray, null, 2));
      //console.log("yooooooooooooooooooooooooooooooooooooo : "+datesWithDayMonthYear);
    }else if (isMobile === true){
      setMySessionsCalendarRenderSessionArray(convertTimeSessionArrayTo303GridNumberSessionArray(props.mySessions));     //Change 303 for calendarRenderSessionArray
      //console.log("1mySessionsCalendarRenderSessionArray : "+JSON.stringify(mySessionsCalendarRenderSessionArray, null, 2));
      //console.log("yooooooooooooooooooooooooooooooooooooo : "+datesWithDayMonthYear);
    }
  },[datesWithDayMonthYear, props.mySessions, subject, category, isMobile])   //calendarRenderSessionArray
  //-------------------------------------------------------------------------------






  //----------------- blacklisted grids (Grids to be avoided) for hovered grids overlay and clicked grids overlay.------------
  //!!!!!!!!!!!!
  const [blacklistedGridNumbersArray, setBlacklistedGridNumbersArray] = useState([]);
  useEffect(()=>{
    const gridNumbersOfMineSessions = mySessionsCalendarRenderSessionArray.map(x => x.gridNumber);
    
    let subtractions;
    if (isMobile === false){
      subtractions = [9, 18, 27, 36, 45];
    }else if (isMobile === true){
      subtractions = [3, 6, 9, 12, 15];
    }

    const blacklistedGridNumbers = gridNumbersOfMineSessions.flatMap(num => subtractions.map(sub => num - sub));  //Flatmap is used to flatten the array of arrays into a single array.
    setBlacklistedGridNumbersArray(blacklistedGridNumbers);
  },[mySessionsCalendarRenderSessionArray, isMobile])
  //--------------------------------------------------------------------------------------------------------------------------




  //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!Instead of doing like this below, just check if the hovered grid (mouse over grid) lowest-limit-time (+15) is less than or equal to the current time. If it is, then don't show the overlay. If it is not, then show the overlay.
  //-----------------To find the past grids upto the time till now and blacklist them so that they can't be hovered or clicked.---------------
  useEffect(()=>{
    const updateBlacklistedGridNumbers = () => {
      if(isMobile === false){
        Array.from({ length: 909 }, (_, index) => {
          if (todaysColumnNumber !== 1){   // Indicates that the current day is in the current week selected.
            if ((index%9) < (todaysColumnNumber-1)){        //index%9 is the column number.
              setBlacklistedGridNumbersArray((prev)=>[...prev, index+1]);
            }else if ((index%9) === (todaysColumnNumber-1)){
              //check the current time and calculate how many grids have passed till now by seeing the timeSlotsArray.
              const now = new Date();
              const secondsElapsedInTheDay = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
              const verticalCurrentGridRow = Math.floor(secondsElapsedInTheDay/(60*15))+1; 

              const currentGridNumberIndex = 9*(verticalCurrentGridRow-1)+(todaysColumnNumber-1);
              if (index <= currentGridNumberIndex){
                setBlacklistedGridNumbersArray((prev)=>[...prev, index+1]);
              }
            }
          }else if (todaysColumnNumber === 1){  // Indicates that the current week selected does not have the current day in it as findIndex returns -1. So 2-1 = 1. Check the todaysColumnNumber calculation.
            if (pastOrPresentOrFuture === 'past'){
              setBlacklistedGridNumbersArray((prev)=>[...prev, index+1]);
            }
          }
            
        });
        //console.log("xblacklistedGridNumbersArray : "+blacklistedGridNumbersArray);
      }else if(isMobile === true){
        Array.from({ length: 303 }, (_, index) => {
          if (todaysColumnNumber !== 1){   // Indicates that the current day is in the current week selected.
            if ((index%3) < (todaysColumnNumber-1)){        //index%9 is the column number.
              setBlacklistedGridNumbersArray((prev)=>[...prev, index+1]);
            }else if ((index%3) === (todaysColumnNumber-1)){
              //check the current time and calculate how many grids have passed till now by seeing the timeSlotsArray.
              const now = new Date();
              const secondsElapsedInTheDay = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
              const verticalCurrentGridRow = Math.floor(secondsElapsedInTheDay/(60*15))+1; 

              const currentGridNumberIndex = 3*(verticalCurrentGridRow-1)+(todaysColumnNumber-1);
              if (index <= currentGridNumberIndex){
                setBlacklistedGridNumbersArray((prev)=>[...prev, index+1]);
              }
            }
          }else if (todaysColumnNumber === 1){  // Indicates that the current week selected does not have the current day in it as findIndex returns -1. So 2-1 = 1. Check the todaysColumnNumber calculation.
            if (pastOrPresentOrFuture === 'past'){
              setBlacklistedGridNumbersArray((prev)=>[...prev, index+1]);
            }
          }
            
        });
        //console.log("xblacklistedGridNumbersArray : "+blacklistedGridNumbersArray);
      }
    }

    // Call the function immediately
    updateBlacklistedGridNumbers();

    const intervalId = setInterval(updateBlacklistedGridNumbers, 10000);    // Update every 10 seconds.  Is it needed because mySessionsCalendarRenderSessionArray is updating every 10 seconds right?

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);

  },[todaysColumnNumber, mySessionsCalendarRenderSessionArray, datesWithDayMonthYear, pastOrPresentOrFuture, isMobile]); //Not sure if datesWithDayMonthYear is needed here.  // It is updating every 10 seconds as mySessionsCalendarRenderSessionArray updates every 10 seconds.(Could add calendarRenderSessionArray as well instead of this.) //currentTimeInSeconds needed? Then it will update every second. 
  //------------------------------------------------------------------------------------------------------------------






  //------------------ Timeslots array for the first column.  -------------------------------------
  const timeSlotsArray = useMemo(() => {
    const array = [];             // [ 12AM, 15, 30, 45, 1AM, 15, 30, ...]
    for (let hour = 0; hour <= 23; hour++) {
        for (let minute = 0; minute <= 45; minute += 15) {
            const formattedHour = (hour % 12 === 0) ? 12 : hour % 12;
            const amPm = (hour < 12) ? 'AM' : 'PM';
            const timeString = (minute === 0) ? `${formattedHour} ${amPm}` : minute;
            array.push(timeString);
        }
    }
    return array;
  }, []);
  //-----------------------------------------------------------------------------------------------




  //--------------------- First and last column array sequence.---------------------------------
  const firstColumnArrayFor303Grids = useMemo(
    () => Array.from({ length: 101 }, (_, index) => index * 3),
    []
  );
  const lastColumnArrayFor303Grids = useMemo(
    () => Array.from({ length: 101 }, (_, index) => 2 + index * 3),
    []
  );

  const firstColumnArrayFor909Grids = useMemo(
    () => Array.from({ length: 101 }, (_, index) => index * 9),
    []
  );
  const lastColumnArrayFor909Grids = useMemo(
    () => Array.from({ length: 101 }, (_, index) => 8 + index * 9),
    []
  );
  //---------------------------------------------------------------------------------------------




  //----------------------- Hour border line sequence array-----------------------------------
  const hourBorderLineSequenceArrayFor303Grids = useMemo(() => {
    const array = [];
    for (let i = 10; i <= 302; i += 12) {
        for (let j = 0; j < 1; j++) {
            array.push(i + j);
        }
    }
    return array;
  }, []);

  const hourBorderLineSequenceArrayFor909Grids = useMemo(() => {
    const array = [];
    for (let i = 28; i <= 908; i += 36) {
        for (let j = 0; j < 7; j++) {
            array.push(i + j);
        }
    }
    return array;
  }, []);
  //------------------------------------------------------------------------------------------









  
  //-----------Finding out height of calendar Grid and set the heightOfCalendarGrid global state value.-------------
  //const [heightOfCalendarGrid, setHeightOfCalendarGrid] = useState(0);

  const panelDivRef = useRef(null);
  //const heightOfCalendarGrid = panelDivRef.current.offsetHeight;   //var or const ?

  useEffect(() => {    // For getting the calendar grid height for rendering the overlay booking box.
    // Update the textarea height whenever the text changes
    if (panelDivRef.current) {
      //console.log(panelDivRef.current);
      // console.log("panel div height : "+ panelDivRef.current.style.height);     //Not the right way.
      //console.log("panel div height : "+ panelDivRef.current.offsetHeight);   //The hight of each calendar grid.
      setHeightOfCalendarGrid(panelDivRef.current.offsetHeight);   //var or const ?
    }
  },[]);     // Only re-run the effect if this second parameter changes. Here we have to give a state if we are to give something. If nothing given (as in if it is left blank), it will re-run the effect everytime there is some change (any change).
  //------------------------------------------------------------------------------------------------------------------




  



  //-----------Setting on which grid the mouse is hovered.--------------------
  //No need to use useCallback for simple functions like this.
  const [hoveredGridFor909, setHoveredGridFor909] = useState([]);     // Add here for 909 grids. 
  const [hoveredGridFor303, setHoveredGridFor303] = useState([]);     // Add here for 303 grids. 
  
  function handleMouseOverFor909(ind){
    if (ind<863){  //854
      setHoveredGridFor909([ind]);
    }
  }

  function handleMouseOverFor303(ind){
    if (ind<287){  
      setHoveredGridFor303([ind]);
    }
  }

  function handleMouseOut(){
    setHoveredGridFor909([]);
    setHoveredGridFor303([]);
  }
  //---------------------------------------------------------------------------

  



  //---------------Setting the grid the mouse clicked.------------------------
  //No need to use useCallback for simple functions like this.
  const [clickedGridFor909, setClickedGridFor909] = useState([]);     // Add here for 909 grids.
  const [clickedGridFor303, setClickedGridFor303] = useState([]);     // Add here for 303 grids.

  function handleGridClickFor909(index){
    if (index<863){    //854
      setClickedGridFor909([index]);
    }
  }

  function handleGridClickFor303(index){
    if (index<287){
      setClickedGridFor303([index]);
    }
  }
  //---------------------------------------------------------------------------





  //-------------useEffect to compute time from the clicked grid index------------------

  useEffect(() => {
    if (clickedGridFor909.length > 0) {
      const index = clickedGridFor909[0];  // Get the current clicked index
      const timeInDayHourMinute = convert909GridIndexToTimeInDayHourMinute(index);
      setClickedGridTimeInDayHourMinute(timeInDayHourMinute);
    }
  }, [clickedGridFor909]);  // Depend on clickedGridFor909

  useEffect(() => {
    if (clickedGridFor303.length > 0) {
      const index = clickedGridFor303[0];  // Get the current clicked index
      const timeInDayHourMinute = convert303GridIndexToTimeInDayHourMinute(index);
      setClickedGridTimeInDayHourMinute(timeInDayHourMinute);
    }
  }, [clickedGridFor303]);  // Depend on clickedGridFor303
  //-----------------------------------------------------------------------------------





  //------------------Setting the default scroll position-------------------------------
  /*
  const scrollDivRef = useRef(null);
  const hasSetScroll = useRef(false); // flag to run only once.     //I think this can be used where ever you want to run something only once. Like for example if you want to display the category info before booking a session for the first time.

  useEffect(() => {
    // const scrollableHeight = scrollDivRef.current.scrollHeight;  //scrollable height.
    // const clientHeight = scrollDivRef.current.clientHeight;

    //scrollDivRef.current.scrollTop = (timeNeedlePosition-13)-50;

    // run once when timeNeedlePosition is calculated (not undefined)
    if (!hasSetScroll.current && timeNeedlePosition !== undefined) {
      scrollDivRef.current.scrollTop = (timeNeedlePosition - 13) - 50;    //Minus 13 for that Needle Trainble offset I guess. Minus 12 has been used in the while rendering. And minus 50 is for the scroll to be a bit above the time needle.
      hasSetScroll.current = true;
    }
    
  }, [timeNeedlePosition]);   //timeNeedlePosition    //It actually needs to update just once not continuosly scroll whenever timeNeedlePosition changes.
  */
  //-----------------------------------------------------------------------------------


  //------------------Setting the default scroll position another method-------------------------------
  const scrollDivRef = useRef(null);
  //const hasSetScroll = useRef(false); // flag to run only once.     //I think this can be used where ever you want to run something only once. Like for example if you want to display the category info before booking a session for the first time.

  useEffect(() => {
    // const scrollableHeight = scrollDivRef.current.scrollHeight;  //scrollable height.
    // const clientHeight = scrollDivRef.current.clientHeight;

    //scrollDivRef.current.scrollTop = (timeNeedlePosition-13)-50;

    // run once when timeNeedlePosition is calculated (not undefined)
    if (heightOfCalendarGrid !== undefined) {
      const now = new Date();
      const secondsElapsedInTheDay = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

      const timeNeedlePositionDistance = Math.floor((secondsElapsedInTheDay/90900)*(101*heightOfCalendarGrid+59));
      
      scrollDivRef.current.scrollTop = (timeNeedlePositionDistance - 13) - 50;    //Minus 13 for that Needle Trainble offset I guess. Minus 12 has been used in the while rendering. And minus 50 is for the scroll to be a bit above the time needle.
      //hasSetScroll.current = true;
    }
    
  }, [heightOfCalendarGrid]);   //timeNeedlePosition    //It actually needs to update just once not continuosly scroll whenever timeNeedlePosition changes.

  //-----------------------------------------------------------------------------------





  /*
  useEffect(()=>{
    console.log("singleDayDateForMobile : "+singleDayDateForMobile);
    console.log("singleDayDateForMobile type : "+typeof(singleDayDateForMobile));
    console.log("today : "+today);
    console.log("today type : "+typeof(today));
  },[singleDayDateForMobile, today]);
  */
  




  
  //------------------return statement below. --------------------------------

  return(

    <Grid container spacing={0} className={props.calendarHeightProp}>  {/*Contains up-and-down child grids.*/}


      
      {/*----------------Calendar upper section--------------- */}
      {/*----------------------------------------------------- */}

      <Grid container xs={30} columns={30} className={styles.calendar_upper_section_grid}>

        {/*----------------Calendar left arrow--------------- */}

        <Grid xs={isMobile? 4.5 : 1} className={styles.calendar_upper_section_left_arrow_panel_grid}>
          <div className={styles.calendar_upper_section_day_panel_div}> 
            {/*<p className={styles.weekday_name'>nnn</p>*/}
            <div onClick={()=>calendarArrowClicked('left')} className={styles.weekday_shift_left_arrow}><SlArrowLeft/></div>                 
          </div>
        </Grid>

        {/*----------------Weekday names and Calendar dates--------------- */}

        {
          isMobile ?
          (
            <Grid xs={22} className={styles.calendar_upper_section_day_panel_grid} style={(singleDayDateForMobile.isSame(today, 'day'))? {backgroundColor: 'rgba(0, 0, 0, 0.1)'}:{}} >
              <div className={styles.calendar_upper_section_day_panel_div}> 
                <p className={styles.weekday_name}>{singleDayDateForMobile.format("dddd")}</p>
                <span className={styles.weekday_date}>{singleDayDateForMobile.format("DD")}</span>                 
              </div>
            </Grid>
          ):(
            weekdayNamesAndDates.map(function(day, index){
              return(
                <Grid key={index} id={index} xs={4} className={styles.calendar_upper_section_day_panel_grid} style={(index === (todaysColumnNumber-2))? {backgroundColor: 'rgba(0, 0, 0, 0.1)'}:{}} >
                  <div className={styles.calendar_upper_section_day_panel_div}> 
                    <p className={styles.weekday_name}>{day[0]}</p>
                    <span className={styles.weekday_date}>{day[1]}</span>                 
                  </div>
                </Grid>
              );
            })
          )
        }

        {/*----------------Calendar right arrow--------------- */}

        <Grid xs={isMobile? 3.5 : 1} className={styles.calendar_upper_section_right_arrow_panel_grid}>
          <div className={styles.calendar_upper_section_day_panel_div}> 
            {/*<p className={styles.weekday_name'>mmm</p>*/}
            <div onClick={()=>calendarArrowClicked('right')} className={styles.weekday_shift_right_arrow}><SlArrowRight/></div>                 
          </div>
        </Grid>
      </Grid>



      {/*----------------Calendar lower section--------------- */}
      {/*------------------------------------------------------ */}

      <SimpleBar 
        className={styles.calendar_lower_section_simplebar}     
        scrollableNodeProps={{ ref: scrollDivRef }}
        autoHide={false}
      >
        <Grid container xs={30} columns={30} className={styles.calendar_lower_section_grid}>
          {(isMobile) ? (






            /*----------------Rendering 303 grids for mobile screen--------------- */
            Array.from({ length: 303 }, (_, index) => {
                {/*----------------First column--------------- */}
                if (firstColumnArrayFor303Grids.includes(index)){         
                  return (
                    <Grid key={index} xs={4.5} className={styles.calendar_lower_section_first_column_panel_grid}>
                      <div key={index} className={styles.calendar_lower_section_panel_div}>
                        {((index===0)?(
                          <div className={styles.timeSlot_12am}>{timeSlotsArray[(index)]}</div>    /*For the top 12 AM slot adjustment.*/
                        ):(
                          <div className={styles.timeSlots}>{timeSlotsArray[(index/3)]}</div>    /*For other time slots.*/
                        ))
                        }
                      </div>
                    </Grid>
                  )
                {/*----------------Last column-------------------*/}
                }else if (lastColumnArrayFor303Grids.includes(index)){   
                  return (
                    <Grid key={index} xs={3.5} className={styles.calendar_lower_section_last_column_panel_grid}>
                      <div key={index} className={styles.calendar_lower_section_panel_div}>
                      </div>
                    </Grid>
                  )
                {/*---------------Middle columns----------------*/}
                }else{                                         
                  return(
                    <Grid key={index} xs={22} onClick={() => handleGridClickFor303(index)} onMouseOver={() => handleMouseOverFor303(index)} onMouseOut={handleMouseOut} className={hourBorderLineSequenceArrayFor303Grids.includes(index) ? (styles.calendar_lower_section_hour_line_panel_grid):(styles.calendar_lower_section_minute_line_panel_grid)}>
                      {(hoveredGridFor303.includes(index) && !blacklistedGridNumbersArray.includes(index+1)) && (<div className={styles.hovered_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
                                                          <CgCheck className={styles.tick}/>
                                                        </div>)}     {/*Hovered overlay*/}      

                      {/*And corresponding date (day, month and year) has to be todays.*/}

                      {(Array.isArray(needleOverlayBoxGridIndex) && needleOverlayBoxGridIndex.includes(index)) && (<NeedleOverlayBox/>)}   {/*To account for that offset*/}                           
                      
                      {(clickedGridFor303.includes(index) && !blacklistedGridNumbersArray.includes(index+1)) && (<props.SessionClickedOverlayBox/>)}                {/*Clicked overlay*/}

                      {/*(clickedGridFor303.includes(index)) && (<props.SessionBookedOverlayBox/>)*/}                {/*Clicked overlay*/}

                      {(mySessionsCalendarRenderSessionArray.find(item=>item.gridNumberMinus1===index)) && (<props.SessionBookedOverlayBox 
                                                                                                      createdPersonId={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).createdBy} 
                                                                                                      isPaired={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).isPaired}
                                                                                                      pairedWithPersonId={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).pairedWith}
                                                                                                      bookedHour={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).hour} 
                                                                                                      bookedMinute={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).minutes} 
                                                                                                      bookedSubject={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).subject} 
                                                                                                      bookedTopic={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).topic} 
                                                                                                      bookedMode={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).mode}
                                                                                                      bookedType={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).type}
                                                                                                    />)
                      }                {/*Booked overlay*/}

                      <div key={index} ref={panelDivRef} className={styles.calendar_lower_section_panel_div}>
                        {/*(multiplesOf9.includes(index)? (<div className={styles.timeSlots'>Q</div>): null)*/}

                        <div className={styles.person_details_div}>
                          {calendarRenderSessionArray
                            .filter(item => item.gridNumberMinus1 === index)
                            .slice(0, 2) // Show only the first 2 avatars
                            .map((item, idx) => (
                              <Avatar
                                key={idx}
                                className={styles.avatar_class}
                                alt="profile_image"
                                src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${item.createdBy}&type=thumbnail`}
                              />
                            ))
                          }
                          {calendarRenderSessionArray.filter(item => item.gridNumberMinus1 === index).length > 2 && (
                            <div className={styles.more_avatars}>
                              +{calendarRenderSessionArray.filter(item => item.gridNumberMinus1 === index).length - 2}
                            </div>
                          )}
                        </div>

                        {/*(calendarRenderSessionArray.find(item=>item.gridNumberMinus1===index))  && (<div className={styles.person_details_div}>
                                                                                                <Avatar className={styles.avatar_class} alt="profile_image" src={((calendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).createdBy) === '66f47f658ac955d8dfbd968e')?'/images/andrej_karpathy.jpg': ((calendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).createdBy) === '66fba07b6b2e10405d0e38fa') ? 'images/paul.jpg' : 'images/urumi.png'}/>
                                                                                                <p className={styles.person_name_class}>{calendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).createdBy}</p>
                                                                                              </div>)
                        */}

                        {/*
                        {([31,13,75].includes(index))  ? (<div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Paul" src='/images/paul.jpg'/><p className={styles.person_name_class}>Paul Sebastian</p></div>): null}
                        {([605,705,54].includes(index))  ? (<div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Urumi" src='/images/urumi.png'/><p className={styles.person_name_class}>Hormis C</p></div>): null}
                        {([67,19,87].includes(index))  ? (<div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className={styles.person_name_class}>Andrej K</p></div>): null}
                        */}
                      </div>
                    </Grid>
                  )
                }
              }
            )
            



          
          ):(
          




            /*----------------Rendering 909 grids for laptop screen--------------- */
            Array.from({ length: 909 }, (_, index) => {
                {/*----------------First column--------------- */}
                if (firstColumnArrayFor909Grids.includes(index)){         
                  return (
                    <Grid key={index} xs={1} className={styles.calendar_lower_section_first_column_panel_grid}>
                      <div key={index} className={styles.calendar_lower_section_panel_div}>
                        {((index===0)?(
                          <div className={styles.timeSlot_12am}>{timeSlotsArray[(index)]}</div>    /*For the top 12 AM slot adjustment.*/
                        ):(
                          <div className={styles.timeSlots}>{timeSlotsArray[(index/9)]}</div>    /*For other time slots.*/
                        ))
                      }
                      </div>
                    </Grid>
                  )
                {/*----------------Last column-------------------*/}
                }else if (lastColumnArrayFor909Grids.includes(index)){   
                  return (
                    <Grid key={index} xs={1} className={styles.calendar_lower_section_last_column_panel_grid}>
                      <div key={index} className={styles.calendar_lower_section_panel_div}>
                      </div>
                    </Grid>
                  )
                {/*---------------Middle columns----------------*/}
                }else{                                         
                  return(
                    <Grid key={index} xs={4} onClick={() => handleGridClickFor909(index)} onMouseOver={() => handleMouseOverFor909(index)} onMouseOut={handleMouseOut} className={hourBorderLineSequenceArrayFor909Grids.includes(index) ? (styles.calendar_lower_section_hour_line_panel_grid):(styles.calendar_lower_section_minute_line_panel_grid)}>
                      {(hoveredGridFor909.includes(index) && !blacklistedGridNumbersArray.includes(index+1)) && (<div className={styles.hovered_overlay} style={{height : `${6*heightOfCalendarGrid+3}px`}}>
                                                          <CgCheck className={styles.tick}/>
                                                        </div>)}     {/*Hovered overlay*/}

                      {/*And corresponding date (day, month and year) has to be todays.*/}

                      {(Array.isArray(needleOverlayBoxGridIndex) && needleOverlayBoxGridIndex.includes(index)) && (<NeedleOverlayBox/>)}   {/*To account for that offset*/}                                 
                      
                      {(clickedGridFor909.includes(index) && !blacklistedGridNumbersArray.includes(index+1)) && (<props.SessionClickedOverlayBox/>)}                {/*Clicked overlay*/}

                      {/*(clickedGridFor909.includes(index)) && (<props.SessionBookedOverlayBox/>)*/}                {/*Clicked overlay*/}

                      {(mySessionsCalendarRenderSessionArray.find(item=>item.gridNumberMinus1===index)) && (<props.SessionBookedOverlayBox 
                                                                                                      createdPersonId={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).createdBy} 
                                                                                                      isPaired={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).isPaired}
                                                                                                      pairedWithPersonId={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).pairedWith}
                                                                                                      bookedHour={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).hour} 
                                                                                                      bookedMinute={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).minutes} 
                                                                                                      bookedSubject={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).subject} 
                                                                                                      bookedTopic={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).topic} 
                                                                                                      bookedMode={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).mode}
                                                                                                      bookedType={mySessionsCalendarRenderSessionArray.find(item => item.gridNumberMinus1 === index).type}
                                                                                                    />)
                      }                {/*Booked overlay*/}


                      <div key={index} ref={panelDivRef} className={styles.calendar_lower_section_panel_div}>
                        {/*(multiplesOf9.includes(index)? (<div className={styles.timeSlots'>Q</div>): null)*/}

                        <div className={styles.person_details_div}>
                          {calendarRenderSessionArray
                            .filter(item => item.gridNumberMinus1 === index)
                            .slice(0, 2) // Show only the first 2 avatars
                            .map((item, idx) => (
                              <Avatar
                                key={idx}
                                className={styles.avatar_class}
                                alt="profile_image"
                                src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?userID=${item.createdBy}&type=thumbnail`}
                              />
                            ))
                          }
                          {calendarRenderSessionArray.filter(item => item.gridNumberMinus1 === index).length > 2 && (
                            <div className={styles.more_avatars}>
                              +{calendarRenderSessionArray.filter(item => item.gridNumberMinus1 === index).length - 2}
                            </div>
                          )}
                        </div>


                        {/*
                        {([31,13,75].includes(index))  ? (<div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Paul" src='/images/paul.jpg'/><p className={styles.person_name_class}>Paul Sebastian</p></div>): null}
                        {([605,705,54].includes(index))  ? (<div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Urumi" src='/images/urumi.png'/><p className={styles.person_name_class}>Hormis C</p></div>): null}
                        {([67,19,87].includes(index))  ? (<div className={styles.person_details_div}><Avatar className={styles.avatar_class} alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className={styles.person_name_class}>Andrej K</p></div>): null}
                        */}
                      </div>
                    </Grid>
                  )
                }
              }
            )
            



          )
          }



        </Grid>
      </SimpleBar>

    </Grid>
  )
}





); //End of memo function.

export default Calendar;

